import {
  ContentWrapper,
  Error,
  InputWrapper,
  ButtonsWrapper,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { CNYProps, FormInputs } from "../../../../../../types/walletTypes";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { Button } from "../../../../../../components/common/Button";
import { InputPhone } from "../../../../../../components/common/InputPhone";
import React from "react";

const WeChatPaymentDetailsForm = ({
  handleNext,
  handlePrevious,
}: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData || {} });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <InputWrapper>
        <Controller
          name="receiverMobileNumber"
          control={control}
          rules={{ required: "WeChat ID or phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="WeChat ID or Phone number"
              field={field}
              defaultCountry="CN"
            />
          )}
        />
        <Error>{errors?.receiverMobileNumber?.message}</Error>
      </InputWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          label="Back"
          height="48px"
          theme="alternate"
          width="203px"
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default WeChatPaymentDetailsForm;
